<template>
  <div class="PasswordChange">
    <section-header heading="2" ja="パスワードの変更"/>
    <template v-if="isUpdate">
      <p-text-field
        placeholder="現在のパスワード"
        type="password"
        v-model="password0"
        @click="password0 = ''"
        @blur="validatePassword0"
      ></p-text-field>
    </template>
    <div class="textArea">英大文字・英小文字・数字をそれぞれ1文字以上含む8文字以上のパスワードを設定してください</div>
    <p-text-field
      placeholder="パスワード"
      type="password"
      v-model="password1"
      @click="password1 = ''"
      @blur="validatePassword1"
    ></p-text-field>
    <p-text-field
      placeholder="パスワード（再入力）"
      type="password"
      v-model="password2"
      @click="password2 = ''"
      @blur="validatePassword2"
    ></p-text-field>
    <rule v-if="!validPasswordRule">
      大小英字と数字を含む8文字以上127文字以下で入力してください
    </rule>
    <rule v-if="validPasswordRule && password1 && password1 !== password2">
      入力されたパスワードが一致しません
    </rule>
    <normal-btn
      :disabled="!validForm"
      @click="onOK">決定</normal-btn>
  </div>
</template>

<script>
import SectionHeader from '../components/SectionHeader.vue'
import NormalBtn from '../components/NormalBtn.vue'
import PTextField from '../components/PTextField'
import Rule from '../components/Rule'
import Protobuf from '../mixins/protobuf'
import Screen from '../mixins/screen'
import Validator from '../mixins/validator'
import { toHash, decodeUrlSafeBase64 } from "../assets/js/util"

const pb = require('../assets/js/kumaproto').kuma.jp.protobuf.web

export default {
  name: "PasswordChange",
  components: {
    SectionHeader,
    NormalBtn,
    PTextField,
    Rule
  },
  mixins: [
    Protobuf,
    Screen,
    Validator
  ],
  data() {
    return {
      password0: '',
      password1: '',
      password2: '',
      password0Rules: ['大小英字と数字を含む8文字以上127文字以下で入力してください'],
      password1Rules: [],
      password2Rules: [],
      hashedPassword0: '',
    }
  },
  computed: {
    isUpdate() {
      return this.$route.path.startsWith('/passwordChange')
    },
    password0Rule() {
      return this.password0Rules.length > 0 ? this.password0Rules[0] : ''
    },
    password1Rule() {
      return this.password1Rules.length > 0 ? this.password1Rules[0] : ''
    },
    password2Rule() {
      return this.password2Rules.length > 0 ? this.password2Rules[0] : ''
    },
    validPasswordRule() {
      let err = this.validPassword(this.password1)
      if (err !== null) {
        return false
      }
      return true
    },
    validForm() {
      if (this.isUpdate) {
        let err = this.samePassword(this.hashedPassword0, this.$store.getters.hashedPassword)
        if (err !== null) {
          return false
        }
      }
      let err = this.validPassword(this.password1)
      if (err !== null) {
        return false
      }
      err = this.samePassword(this.password1, this.password2)
      if (err !== null) {
        return false
      }
      return true
    }
  },
  methods: {
    validatePassword0() {
      this.password0Rules = []
      this.hashedPassword0 = toHash('sha512', this.password0)
      const err = this.samePassword(this.hashedPassword0, this.$store.getters.hashedPassword)
      if (err !== null) {
         this.password0Rules.push(err.message)
      }
    },
    validatePassword1() {
      this.password1Rules = []
      const err = this.validPassword(this.password1)
      if (err !== null) {
        this.password1Rules.push(err.message)
      }
    },
    validatePassword2() {
      this.password2Rules = []
      const err = this.samePassword(this.password1, this.password2)
      if (err !== null) {
        this.password2Rules.push(err.message)
      }
    },
    onOK() {
      if (this.isUpdate) {
        this.update()
      } else {
        this.reset()
      }
    },
    update() {
      const cmdNo = pb.PlayerUpdateInfoReq.CommandNo.COMMAND_NO
      const message = pb.PlayerUpdateInfoReq.create({
        updateType: pb.PlayerUpdateInfoReq.UpdateType.PASSWORD,
        password: this.password1
      })
      const encoded = pb.PlayerUpdateInfoReq.encode(message).finish()
      this.post(cmdNo, encoded)
        .then(decoded => {
          if (decoded.status === pb.PlayerUpdateInfoResp.Status.SUCCESS) {
            this.$store.dispatch('savePassword', this.password1)
            this.$router.push('/passwordChangeFinish')
          } else {
            this.$_error('Error', { title: 'パスワードの変更', statusCode: 100 })
          }
        })
        .catch(() => {
          this.$_error('Error', { title: 'パスワードの変更', statusCode: 100 })
        })
    },
    reset() {
      const cmdNo = pb.PlayerResetPassReq.CommandNo.COMMAND_NO
      const message = pb.PlayerResetPassReq.create({
        validateKey: this.$route.query.validateKey,
        password: this.password1
      })
      const encoded = pb.PlayerResetPassReq.encode(message).finish()
      this.post(cmdNo, encoded)
        .then(decoded => {
          if (decoded.status === pb.PlayerUpdateInfoResp.Status.SUCCESS) {
            this.$store.dispatch('savePassword', this.password1)
            this.$router.push('/passwordChangeFinish')
          } else {
            this.$_error('Error', { title: 'パスワードの変更', statusCode: 100 })
          }
        })
        .catch(() => {
          this.$_error('Error', { title: 'パスワードの変更', statusCode: 100 })
        })
    },
    checkValidateKey() {
      const cmdNo = pb.PlayerValidateKeyCheckReq.CommandNo.COMMAND_NO
      const message = pb.PlayerValidateKeyCheckReq.create({
        validateKey: this.$route.query.validateKey
      })
      const encoded = pb.PlayerValidateKeyCheckReq.encode(message).finish()
      this.post(cmdNo, encoded)
        .then(decoded => {
          if (decoded.status === pb.PlayerValidateKeyCheckResp.Status.SUCCESS) {
            this.$store.dispatch('saveMailAddress', decoded.mailAddress)
          } else if(decoded.status === pb.PlayerValidateKeyCheckResp.Status.FAILED) {
            this.$_error('Error', { title: 'パスワードの変更', statusCode: 403 })
          } else if(decoded.status === pb.PlayerValidateKeyCheckResp.Status.EXPIRED) {
            this.$_error('Error', { title: 'パスワードの変更', statusCode: 402 })
          }
        })
        .catch(() => {
          this.$_error('Error', { title: 'パスワードの変更', statusCode: 100 })
        })
    }
  },
  mounted() {
    if (!this.isUpdate) { //reset
      this.password1Rules.push('大小英字と数字を含む8文字以上127文字以下で入力してください')
      this.checkValidateKey()
    } else if (this.$route.params.playerId) {
      if (decodeUrlSafeBase64(this.$route.params.playerId) !== this.$store.getters.md5playeerId) {
        // アカウント不一致
        const cmdNo = pb.LogoutReq.CommandNo.COMMAND_NO
        const message = pb.LogoutReq.create({
          token: this.$store.getters.token
        })
        const encoded = pb.LogoutReq.encode(message).finish()
        this.post(cmdNo, encoded)
          .then(decoded => {
            if (decoded.status === pb.LogoutResp.Status.SUCCESS) {
              this.$store.dispatch('logout')
              this.$router.push({ path: '/login', query: { to: '/passwordChange' } })
            } else {
              this.$_error('Error', { title: 'プロフィール', statusCode: 413 })
            }
          })
          .catch(() => {
            this.$_error('Error', { title: 'プロフィール', statusCode: 100 })
          })
      }
    }
  }
}
</script>

<style scoped>
.textArea {
  padding: 30px 30px 0;
  font-size: 12px;
  color: #373737;
}
</style>
